import { useAuth } from './useSupabase';
import supabase from '../lib/supabase';

/**
 * Hook to log admin actions to the database
 */
export const useAuditLog = () => {
  const { user } = useAuth();

  const logAction = async (action, resource, description, metadata = {}) => {
    if (!user || !user.email) {
      console.warn('Cannot log action: No user logged in');
      return;
    }

    try {
      const { error } = await supabase
        .from('audit_logs_aox1234')
        .insert([
          {
            user_email: user.email,
            action,
            resource,
            description,
            metadata,
            created_at: new Date().toISOString()
          }
        ]);

      if (error) {
        console.error('Failed to write audit log:', error);
      }
    } catch (err) {
      console.error('Error logging action:', err);
    }
  };

  return { logAction };
};